import React, { useEffect } from 'react';
import './ProjectCard.scss';

const ProjectCard = ({
    title,
    imgUri,
    getProID,
    tileSize,
    transformSize,
    onHoverFunction,
    active,
    id,
    checkFinishReading
}) => {

    const handleClick = () => {
        console.log(id);
        getProID(id);
        checkFinishReading(true);
    };

    return (
        <div className="EventSliderTiles mx-2"
            id={`${imgUri}tile`}
            style={{
                width: `${tileSize}px`,
                height: `${tileSize}px`,
                transform: `translateY(${transformSize}px) scale(${active ? 1 : 0.8})`,
                transition: '1s',
            }}
        >
            <div className="event-tile-titles">{title}</div>
            <div className="event-tile-see-more-btns" onClick={handleClick}>View Event</div>
            <div className="event-tile-img-filters"></div>
            <div className="event-tile-img-containers">
                <img src={imgUri} alt="" className="event-tile-imgs" />
            </div>
        </div>
    );
};

export default ProjectCard;
